/* eslint-disable react/jsx-filename-extension */

import React from 'react';
import ReactDOM from 'react-dom';

import DownloadForm from './DownloadForm';

const downloadFormContainers = document.querySelectorAll('[data-download-form]');
[...downloadFormContainers].forEach((downloadFormContainer) => {
    const data = {...downloadFormContainer.dataset};
    data.placeholders = JSON.parse(data.placeholders);
    data.termsMessage = JSON.parse(data.termsMessage);
    data.thankYouMessage = JSON.parse(data.thankYouMessage);

    ReactDOM.render(<DownloadForm {...data} />, downloadFormContainer);
});
